import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { getScopeWheelHeroTags } from '../../api/scope_wheel_heroes';

const WheelTagPicker = ({ value, onChange, isDisabled }) => {
  const [groups, setGroups] = useState([]);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError('');
    getScopeWheelHeroTags()
      .then(result => { if (active) setGroups(result); })
      .catch(() => { if (active) setError('Could not load tags.'); })
      .finally(() => { if (active) setIsLoading(false); });
    return () => { active = false; };
  }, [attempt]);

  return (
    <div className='wheel-tag-picker'>
      <label htmlFor='wheel-hero-tags'>Video tags</label>
      <Select
        inputId='wheel-hero-tags'
        isMulti
        isSearchable
        closeMenuOnSelect={false}
        isDisabled={isDisabled || isLoading || !!error}
        isLoading={isLoading}
        options={groups}
        value={value}
        getOptionValue={tag => `${tag.kind}:${tag.id}`}
        getOptionLabel={tag => tag.label}
        onChange={tags => onChange(tags || [])}
        isOptionDisabled={() => value.length >= 40}
        placeholder='Search seasons, clothing types, gender, occasions…'
        noOptionsMessage={() => 'No matching tags'}
      />
      <div>Choose all that apply. Tags describe the video; they do not change where it appears.</div>
      {error && <div role='alert'>{error} <button type='button' onClick={() => setAttempt(count => count + 1)}>Retry</button></div>}
    </div>
  );
};

WheelTagPicker.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool
};

export default WheelTagPicker;
